import { createStore, combineReducers } from 'redux';
import localForage from 'localforage';

const dataStateReducer = (state = {}, action) => {
  switch (action.type.toLowerCase()) {
    case 'data':
      return Object.assign({}, state, {
        [action.key]: action.value
      });
    default:
      return state;
  }
}

const setupStateReducer = (state = {}, action) => {
  switch (action.type.toLowerCase()) {
    case 'setup':
      return Object.assign({}, state, {
        [action.key]: action.value
      });
    default:
      return state;
  }
}

const stateReducer = combineReducers({
  data: dataStateReducer,
  setup: setupStateReducer,
})

let storeInstance = null;

export default class Storage {

  static getStore() {
    if (!storeInstance) {
      storeInstance = createStore(stateReducer);
    }
    return storeInstance;
  }

  //Data
  static saveData(key, data) {
    localForage.setItem(`pnthn-client:data:${key}`, data || null);
    this.setData(key, data);
  }

  static setData(key, data) {
    this.getStore().dispatch({
      type: 'data',
      key: key,
      value: data,
    });
  }

  static getData(key) {
    return this.getStore().getState()['data'][key];
  }

  static async loadData(key) {
    try {
      const data = await localForage.getItem(`pnthn-client:data:${key}`);
      this.getStore().dispatch({
        type: 'data',
        key: key,
        value: data,
      });
      return data;
    } catch (ex) {
      return null;
    }
  }

  static removeData(key) {
    localForage.removeItem(`pnthn-client:data:${key}`);
    this.setData(key, null);
  }

  // Setup
  static setSetup(key, value) {
    this.getStore().dispatch({type: 'setup', key, value});
  }
  static getSetup(key) {
    return this.getStore().getState()['setup'][key];
  }
  
}
